import { connect } from 'react-redux';
import Auth from './Auth';
import { actions } from './actions';

function mapStateToProps(state) {
  return {
    validToken: state.auth.validToken,
    redirectTo: state.auth.redirectTo,
    requestProcessed: state.auth.requestProcessed,
    isExternalUser: state.auth.isExternalUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    validateToken: (redirectPath) => dispatch(actions.validateToken(redirectPath))
  };
}

const AuthContainer = connect(mapStateToProps, mapDispatchToProps)(Auth);

const route = {
  path: '/auth',
  component: AuthContainer
};

export default AuthContainer;
export { route, mapStateToProps, mapDispatchToProps, AuthContainer as Auth };